<ng-container *ngIf="!!ids && { infos: (performerInfos | sortByIds: ids:'performerId') } as vars">
  <add-manage-wrapper *ngIf="displayType === displayTypes.narrowPod" [hideHRule]="true" class="performer-list" titleIcon="performers18" wrapperTitle="Performers" [openLabel]="readOnly ? '' : '+ ADD A PERFORMER'" (open)="addPerformersToASession($event)">
    <ng-container *ngIf="sessionInfo && sessionInfo.fullSession !== undefined">
      <div class="empty-text" *ngIf="noPerformers">{{ emptyText }}</div>
      <ng-container *ngFor="let pInfo of vars.infos; trackBy: trackByPInfo">
        <status-wrapper 
          *ngIf="performers[pInfo.performerId] as performer" 
          [status]="modifiedStatus[pInfo.performerId] || pInfo.status || performerStatus.NotInvited" 
          [threeDotOptions]="threeDotOptions"
          [briefStatus]="!showBriefStatus ? null : modifiedBriefStatus[pInfo.performerId] || pInfo.briefStatus || briefStatus.NotBriefed"
          [readOnly]="readOnly"
          (threeDotSelection)="dotMenuSelection($event, performer)" 
          (changeStatus)="changeStatus(pInfo.performerId, $event)" 
          (changeBriefStatus)="changeBriefStatus(pInfo.performerId, $event)">
          <performer-card [performer]="performer" [bold]="true"></performer-card>
          <div style="margin-left: 10px;">
            <performer-role-editor [programId]="sessionInfo.programId" [session]="sessionInfo.fullSession" [performerId]="pInfo.performerId" [event]="event" [readOnly]="readOnly"
             [role]="sessionInfo?.fullSession?.performerRoles[pInfo.performerId] ? sessionInfo?.fullSession?.performerRoles[pInfo.performerId] : undefined"
            ></performer-role-editor>
            <ng-container *ngIf="!!sessionInfo && !!event" [ngTemplateOutlet]="performerRole" [ngTemplateOutletContext]="{ performerId: pInfo.performerId }"></ng-container>
          </div>             
        </status-wrapper>
      </ng-container>
    </ng-container>
  </add-manage-wrapper>

  <add-manage-wrapper 
    cdkDropList 
    class="performer-list wide"
    *ngIf="displayType === displayTypes.widePod && sessionInfo" 
    [titleIcon]="'performers18'"
    [hideHRule]="true" 
    [wrapperTitle]="'Performers'" 
    [openLabel]="readOnly ? '' : '+ ADD A PERFORMER'" 
    (open)="addPerformersToASession($event)"
    (cdkDropListDropped)="dropPerformerIds($event)">
      <div class="empty-text" *ngIf="noPerformers">{{ emptyText }}</div> <!-- This is not completely correct -->
      <ng-container *ngFor="let pInfo of vars.infos; trackBy: trackByPInfo">
        <div class="drag-wrapper" cdkDrag *ngIf="performers[pInfo.performerId] as performer">
          <icon class="handle" matIcon="drag_indicator" cdkDragHandle></icon>
          <status-wrapper      
            [ngClass]="{ clickable: !readOnly }"
            (click)="readOnly ? null : editPerformer(performer)"
            [status]="modifiedStatus[pInfo.performerId] || pInfo.status || performerStatus.NotInvited" 
            [threeDotOptions]="threeDotOptions"
            [wideFormat]="true"
            [readOnly]="readOnly"
            [briefStatus]="!showBriefStatus ? null : modifiedBriefStatus[pInfo.performerId] || pInfo.briefStatus || briefStatus.NotBriefed"
            (threeDotSelection)="dotMenuSelection($event, performer)"
            (changeStatus)="changeStatus(pInfo.performerId, $event)" 
            (changeBriefStatus)="changeBriefStatus(pInfo.performerId, $event)" 
            >
            <performer-card class="wideContent" [performer]="performer" [bold]="true"></performer-card>
            <div class="wideContentInnerRight" *ngIf="!!sessionInfo && !!event && sessionInfo.fullSession && performer.id && sessionInfo.fullSession.performerRoles as sessionPerformerRoleKey">
              <performer-role-editor [programId]="sessionInfo.programId" [session]="sessionInfo.fullSession" [performerId]="performer.id" [event]="event" [readOnly]="readOnly"
                [role]="performerRoles ? performerRoles[sessionPerformerRoleKey[performer.id]] : undefined"></performer-role-editor>
              <!-- -->         
            </div>

          </status-wrapper>
        </div>
      </ng-container>
  </add-manage-wrapper>
  <add-manage-wrapper *ngIf="displayType === displayTypes.editableCard" [hideHRule]="true" class="performer-list" wrapperTitle="PERFORMERS" openLabel="+ ADD A PERFORMER" (open)="addPerformersToASession($event)">
    <ng-container *ngIf="sessionInfo">
      <ng-container *ngFor="let pInfo of vars.infos; trackBy: trackByPInfo">
        <status-wrapper 
          *ngIf="performers[pInfo.performerId]" 
          [status]="modifiedStatus[pInfo.performerId] || pInfo.status || performerStatus.NotInvited" 
          [briefStatus]="!showBriefStatus ? null : modifiedBriefStatus[pInfo.performerId] || pInfo.briefStatus || briefStatus.NotBriefed"
          [deleteTitle]="'Remove ' + performers[pInfo.performerId]?.name + ' from this session'" 
          (changeStatus)="changeStatus(pInfo.performerId, $event)" 
          (changeBriefStatus)="changeBriefStatus(pInfo.performerId, $event)"
          (clickButton)="editPerformer(performers[pInfo.performerId])" 
          (delete)="deleteFromSession(pInfo.performerId)" buttonText="EDIT PERFORMER">
          <performer-card [performer]="performers[pInfo.performerId]" [bold]="true"></performer-card>
        </status-wrapper>
      </ng-container>
    </ng-container>
  </add-manage-wrapper>
  <div class="read-only-holder" *ngIf="displayType === displayTypes.readOnly">
    <h5>PERFORMERS</h5>
    <ng-container *ngFor="let pInfo of vars.infos; trackBy: trackByPInfo">
      <performer-card class="read-only-card" *ngIf="performers[pInfo.performerId]" [performer]="performers[pInfo.performerId]" [bold]="true"></performer-card>
    </ng-container>
    <div class="empty-text" *ngIf="!vars.infos.length">No performers</div>
  </div>
  <ng-container *ngIf="displayType === displayTypes.listOnly && sessionInfo">
    <ng-container *ngFor="let pInfo of vars.infos">
      <ng-container *ngIf="performers[pInfo.performerId]" [ngTemplateOutlet]="performerListInfo" [ngTemplateOutletContext]="{p: performers[pInfo.performerId]}">
      </ng-container>
    </ng-container>
<!--     <div class="open-limit" class="performer" *ngIf="limited && initialLimit < vars.infos.length" (click)="$event.stopPropagation(); limited = false">...</div> -->
  </ng-container>
  <ng-container *ngIf="displayType === displayTypes.snapshot && staticPerformerData">
    <ng-container *ngFor="let pId of staticPerformerData.performerIdsBySessionIds[sessionId]">
      <ng-container *ngIf="staticPerformerData.performers[pId]" [ngTemplateOutlet]="performerListInfo" [ngTemplateOutletContext]="{p: staticPerformerData.performers[pId]}">
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="displayType === displayTypes.staticList">
    <ng-container *ngFor="let pId of ids">
      <ng-container *ngIf="performers[pId]" [ngTemplateOutlet]="performerListInfo" [ngTemplateOutletContext]="{p: performers[pId]}">
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="displayType === displayTypes.staticCard">
    <ng-container *ngFor="let performerId of ids">
      <performer-card class="read-only-card" [onlyName]="true" [size]="24" *ngIf="performers[performerId]" [performer]="performers[performerId]"></performer-card>
    </ng-container>
  </ng-container>
</ng-container>


<ng-template #performerRole let-performerId="performerId">
  <ng-container *ngIf="sessionInfo.fullSession && sessionInfo.fullSession.performerRoles && sessionInfo.fullSession.performerRoles[performerId] && { role: performerRoles[sessionInfo.fullSession.performerRoles[performerId]+''] } as role">
    <button *ngIf="!readOnly && !role.role" mat-button class="secondary" (click)="editPerformerRole(performerId, $event)">+ PERFORMER ROLE</button>
    <menu-hover-button *ngIf="!!role.role"
      id="entity-type"
      [mobileText]="true"
      [readOnly]="readOnly"
      [iconSelector]="'performers18'" 
      [hoverText]="'Performer role'" 
      [text]="role.role.name || 'Unnamed Role'"
      [tooltipLeft]="true"
      (click)="readOnly ? null : editPerformerRole(performerId, $event)">
    </menu-hover-button>
  </ng-container>

</ng-template>

<ng-template #performerListInfo let-p="p">
  <div class="performer"><b>{{p.name}}</b>{{(p.line1 ? ', ' : '') + (p.line1 || '' )}}{{(p.line2 ? ', ' : '') + (p.line2 || '')}}</div>
</ng-template>